import RealtimeKeyword from './realtimeKeyword/RealtimeKeyword';
import { isNotDefined, not, getFirstObjectHasProperty, namespace } from './../utils/util';

(function ($, global) {
  "use strict";

  // import tram
  require('../vendor/tram-v0.8.3/tram');

  namespace('nc.lineage');

  nc.lineage.searchRealtimeKeyword = function (options) {
    if (isNotDefined(options)) throw new Error('nc.lineage.searchRealtimeKeyword require options object');

    const keyword = global.popularKeyword;
    if (isNotDefined(keyword) || not(Array.isArray)(keyword.data) || keyword.data.length <= 0) return;

    const data = getFirstObjectHasProperty(keyword.data, 'pos', options.pos);
    if (isNotDefined(data)) return;

    return new RealtimeKeyword({
      service: options.service,
      wrap: options.wrap,
      serverId: options.serverId,
      data: data,
      alias: options.alias,
      global: global
    }).init();
  };
}(jQuery, window));


// WEBPACK FOOTER //
// ./_src/js/search/search-realtime-keyword.js